import { useNavigate, Outlet, useLocation, Navigate } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material'
import Header from '../../components/Header'
import { useState } from 'react';
import { useEffect } from 'react';
import { getAllProjects, getAllZones, getAllAdmins, getAllChemicals, getAllActions, getAllTypes, getAllWeeds } from '../../features/db/data';
import { useSelector } from 'react-redux';
import { selectUser } from '../../features/auth/authSlice';

export default function AdminPage() {
	let location = useLocation();
	let idx = 0;

	const tabs = ["projects","zones","chemicals","actions","types","weeds"];

	idx = tabs.lastIndexOf(location.pathname.split('/')[2]);

	if(idx===-1)
	{
		idx = 0;
	}

	const [tab, setTab] = useState(idx);

	const navigate = useNavigate();

	const handleTab = (event, newValue) => 
	{
		setTab(newValue);
	};
	
	const unmapTab = (temp) => 
	{
		return tabs[temp];
	}

	const changeTab = (temp)=>
	{
		if(!temp)
		{temp = tab;}
		navigate(encodeURIComponent(unmapTab(temp)));
	}

	useEffect(
		()=>{changeTab()},
		[tab]
	);

	const [zones, setZones] = useState([]);
	const [projects, setProjects] = useState([]);
	const [admins, setAdmins] = useState([]);
	const [adminsLoaded,setAdminsLoaded] = useState(false);
	const [chemicals,setChemicals] = useState([]);
	const [actions,setActions] = useState([]);
	const [types,setTypes] = useState([]);
	const [weeds,setWeeds] = useState([]);


	useEffect(
		()=>{
			getAllProjects().then((temp) => { setProjects(temp) });
			getAllZones().then((temp) => { setZones(temp) });
			getAllAdmins().then((temp) => { setAdmins(temp);setAdminsLoaded(true)});
			getAllChemicals().then((temp) => { setChemicals(temp) });
			getAllActions().then((temp) => { setActions(temp) });
			getAllTypes().then((temp) => { setTypes(temp) });
			getAllWeeds().then((temp) => { setWeeds(temp) });
		},
		[]
	);
	
	const user = useSelector(selectUser);

	const determinAdmin = ()=>
	{
		if(user)
		{
			if(admins.includes(user.uid))
			{
				return true;
			}
		}
		return false;
	}

	const isAdmin = determinAdmin();

	return (
		adminsLoaded?
		<>
			{!isAdmin?<Navigate to="/" />:null}
			<div>
				<Header title="ADMINISTRATION" />
				<Box>
					<Tabs value={tab} onChange={handleTab} variant="fullWidth">
						{tabs.map((tab,idx)=>{return <Tab key={`${idx}`} label={tab}/>})}
					</Tabs>
				</Box>
				<Outlet context={{
					projectsContainer	: [projects,setProjects],
					zonesContainer 		: [zones, setZones],
					chemicalsContainer	: [chemicals,setChemicals],
					actionsContainer	: [actions,setActions],
					typesContainer		: [types,setTypes],
					weedsContainer		: [weeds,setWeeds],
				}}/>
			</div>
		</>
		:null
	);
}